import { GETv1FundRanks, GETv1PerformaceRanking } from '@fe-news/api/fund';
import { createQueryKeys } from '@lukemorales/query-key-factory';

const performaceRanking = ({
  fundGroup,
  onShore,
  rangeType
}: {
  fundGroup: number | string;
  onShore: number | string;
  rangeType: number | string;
}) => {
  const key = `${fundGroup}-${onShore}-${rangeType}`;

  return {
    queryKey: [key] as [string],
    queryFn: () => GETv1PerformaceRanking({ fundGroup, onShore, rangeType })
  };
};

const fundRedirect = (type: string, subtype: number, days: number) => {
  const key = `aside-fund-${type}-${subtype}-${days}`;

  return {
    queryKey: [key] as [string],
    queryFn: () => GETv1FundRanks(type, subtype, days)
  };
};

const funds = createQueryKeys('funds', {
  performaceRanking,
  fundRedirect
});

export default funds;
